import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { getMap } from '../services/fortniteApi';
import { Map as MapIcon, Maximize, ZoomIn, ZoomOut } from 'lucide-react';

const MapPage = () => {
  const [mapData, setMapData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    const fetchMap = async () => {
      try {
        const data = await getMap();
        setMapData(data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchMap();
  }, []);

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-16 h-16 border-4 border-purple-500/20 border-t-purple-500 rounded-full animate-spin"></div>
    </div>
  );

  return (
    <div className="pt-[calc(var(--nav-height)+2rem)] pb-20 px-8 max-w-7xl mx-auto h-[calc(100vh-var(--nav-height))] flex flex-col">
      <header className="mb-8 flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div>
          <div className="flex items-center gap-2 mb-2 text-green-500">
            <MapIcon className="w-5 h-5" />
            <span className="text-xs font-bold uppercase tracking-widest">Carte actuelle</span>
          </div>
          <h1 className="text-5xl font-black uppercase">L'ÎLE</h1>
        </div>
        
        <div className="flex gap-4">
          <button 
            onClick={() => setZoom(Math.max(1, zoom - 0.5))}
            className="glass-card w-12 h-12 flex items-center justify-center hover:bg-white/5 transition-all"
          >
            <ZoomOut className="w-5 h-5" />
          </button>
          <button 
            onClick={() => setZoom(Math.min(3, zoom + 0.5))}
            className="glass-card w-12 h-12 flex items-center justify-center hover:bg-white/5 transition-all"
          >
            <ZoomIn className="w-5 h-5" />
          </button>
          <div className="glass-card px-6 py-3 flex items-center gap-3">
             <Maximize className="w-4 h-4 text-white/40" />
             <span className="text-sm font-medium">Zoom: {zoom}x</span>
          </div>
        </div>
      </header>

      <div className="flex-1 glass-card overflow-hidden relative cursor-move bg-black/20">
        <motion.div 
          className="w-full h-full flex items-center justify-center"
          animate={{ scale: zoom }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        >
          <img 
            src={mapData?.images?.blank || mapData?.images?.pois} 
            alt="Fortnite Map" 
            className="max-w-full max-h-full object-contain shadow-2xl"
          />
        </motion.div>
        <div className="absolute bottom-6 left-6 bg-black/60 backdrop-blur-md px-4 py-2 rounded-lg border border-white/10">
          <p className="text-xs font-bold text-white/60 mb-1">NOTES DE L'EXPLORATEUR</p>
          <p className="text-sm">Explorez les points d'intérêt et découvrez les secrets de cette saison.</p>
        </div>
      </div>
    </div>
  );
};

export default MapPage;
